import React from 'react';
import { User } from 'model';
import { UserCard } from './UserCard';

export function AccountProfile({ account }: { account: User }) {
  return <UserCard user={account} />;
}
